import { css } from 'styled-components';

export const outer = css`
  min-height: 100px;
`;
